import { Category } from 'models/Category';
import { categoriesCollection } from 'providers/Firestore';

class CategoryService {
  async getCategories() {
    const query = await categoriesCollection.orderBy('name', 'asc').get()
    const categories = query.docs.map(doc =>
      Object.assign(new Category(), { id: doc.id, ...doc.data() })
    )

    return categories
  }
}

export default new CategoryService()

